import {
  Box, Button, CardActions, Grid, Stack, Typography, Tooltip
} from '@mui/material';
import { isEmpty } from 'lodash';
import { Printer } from 'mdi-material-ui';
import moment from 'moment';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { apiService } from '../../../api/axiosClient';
import Page from 'src/components/Page';
import PageHeader from 'src/components/page-header';
import { getOrderNumbers } from 'src/utils/shop';
import MenuShingo from 'src/views/menu/MenuShingo';
import TableShingo from 'src/views/order/TableShingo';
import BoxWrapper from '../../../styles/BoxWrapper';
import { onStateUpdate } from '../../../utils/orderHandler';

const ShingoList = () => {
  const [reload, setReload] = useState(0);
  const [filters, setFilters] = useState({});
  const [selected, setSelected] = useState([]);

  const onDeliveryNotify = async (data) => {

    if(data.shipment_date == null) {
      toast.error('배송완료를 위해서는 출고일자를 입력해야 합니다.');
      return false;
    }

    if(isEmpty(data.tracking_number)) {
      toast.error('배송완료를 위해서는 송장번호를 입력해야 합니다.');
      return false;
    }

    const params = {
      "userName": data.orderer,
      "orderNo": data.orderid,
      "relDate": moment(data.shipment_date).format("YYYY-MM-DD"),
      "invoice": data.tracking_number,
      "orderContact": data.orderer_contact,
    };

    try {
      await apiService.post('/biztalk/delivery', params);
      toast.success('주문자에게 Biztalk으로 알림이 발송되었습니다.');
      return true;
    } catch (error) {
      console.error("Error sending delivery notification:", error);
      return false;
    }
    
  }

  const onStateChange = async (status) => {
  for (const data of selected) {
    const notified = await onDeliveryNotify(data);
    if (notified) {
      onStateUpdate(data, status, () => {
        toast.success('수정 되었습니다');
      });
    }
  }
  setReload(reload => reload + 1);
}

  return (
    <Page title="신고관리">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                <Typography variant='h5' color='#666CFF'>
                신고관리
                </Typography>
            </Stack>
          }
          subtitle={
            <Typography variant='body2'>
              신고관리 리스트를 보여줍니다.
            </Typography>
          }
        />
        <BoxWrapper>
          <Box sx={{ width: '100%', typography: 'body1' }}>            
            <MenuShingo setFilters={setFilters} setReload={setReload} />
          </Box>

          <TableShingo filters={filters} submit={reload} selected={selected} setSelected={setSelected} />

          <CardActions className='card-action-dense'>
            <Stack direction="row" spacing={2}>
              <Tooltip title="주문자에게 Biztalk으로 알림이 발송됩니다. 그리고 포인트 적립이 됩니다.">
                <Button variant='contained' color="warning" onClick={() => {onStateChange("배송완료")}}>배송완료</Button>
              </Tooltip>
            </Stack>
            <Stack direction="row" spacing={2} sx={{pl: 4}}>          
              <Button component={Link} 
                to={`/form/order?orderids=${getOrderNumbers(selected)}`} 
                target="_blank" 
                variant='contained' color='success' startIcon={<Printer />} disabled={selected.length === 0}>거래명세</Button>
              <Button component={Link} 
                to={`/form/delivery?orderids=${getOrderNumbers(selected)}`} 
                target="_blank" 
                variant='contained' color='success' startIcon={<Printer />} disabled={selected.length === 0}>납품명세</Button>
              <Button component={Link} 
                to={`/form/spec?orderids=${getOrderNumbers(selected)}`} 
                target="_blank" 
                variant='contained' color='success' startIcon={<Printer />} disabled={selected.length === 0}>견적서</Button>
            </Stack>
          </CardActions>

        </BoxWrapper>
      </Grid>
    </Page>
  )
}

export default ShingoList